import color from './color';
import { getSizes } from './size';

const { shadow: shadowColor } = color;

export const getShadow = (inPixels = false) => {
  const size = getSizes(inPixels);

  return {
    short: `0 1px ${size.half} ${shadowColor.primary.default(0.2)}`,
    shortHover: `0 1px ${size.half} ${shadowColor.primary.default(0.5)}`,
    shortDarker: `0 1px ${size.unit} ${shadowColor.primary.default(0.3)}`,
    modal: `0 ${size.oneAndHalf} ${size.quad} ${shadowColor.primary.default(0.15)}`,
    modalDarker: `0 ${size.units(1)} ${size.units(4)} ${shadowColor.primary.default(
      0.8,
    )}`,
    template: `0 -1px 1px ${shadowColor.primary.default(0.15)}`,
  };
};
